"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentRequiredInterlock = void 0;
const llm_consensus_1 = require("@branch-ts/llm-consensus");
const llm_consensus_2 = require("@branch-ts/llm-consensus");
exports.PaymentRequiredInterlock = {
    cause: "PaymentRequired",
    hint: () => "Your available AI usage is used up. Review your usage options to continue.",
    sanityCheck: async () => ({
        pass: false,
        hint: "Review your usage options, or wait for your allowance to refresh before retrying.",
    }),
};
llm_consensus_2.InterlockRegistryMechanism.register(exports.PaymentRequiredInterlock);
llm_consensus_1.InterlockCompleteFailureMechanism.register({
    reason: "PaymentRequired",
});
